/**
 * Юридические документы: где они на самом деле лежат.
 *
 * Документы — часть **лендинга** (`seeno.ru`), а не кабинета: это статика
 * маркетингового артефакта, и раздаётся она со слэшем в конце. Кабинет —
 * отдельный бандл, и своего `/license` у него нет и не будет.
 *
 * Пока адреса писались в разметке относительными (`<a href="/license">`),
 * экран оформления просил принять договор, который клиент физически не мог
 * открыть: SPA такого маршрута не знает и отдавала свою страницу «ОШИБКА 404 ·
 * Такого раздела нет». Переход вдобавок перезагружал страницу и терял
 * заполненную форму. Юридически это значит, что акцепт брали под документ,
 * недоступный для чтения.
 *
 * Отсюда два правила, которые держит этот файл:
 *
 *  * адрес **абсолютный** и с завершающим слэшем — ровно тот, по которому
 *    документ отдаётся;
 *  * ссылка открывается в новой вкладке (`LEGAL_LINK_PROPS`), чтобы чтение
 *    договора не стирало наполовину заполненную форму оплаты.
 */

const LANDING = 'https://seeno.ru';

/**
 * Четыре документа, и каждый по своему адресу.
 *
 * Здесь было три: политика конфиденциальности не упоминалась вовсе, а `privacy`
 * означало согласие на обработку — при том, что по `/privacy/` лежала политика.
 * Ссылок на документ, который называет форма регистрации, попросту не было.
 */
export const LEGAL = {
  /** Публичная оферта: договор, который заключается принятием. */
  offer: `${LANDING}/license/`,
  /** Пользовательское соглашение. */
  terms: `${LANDING}/terms/`,
  /** Политика конфиденциальности: что и зачем обрабатывается. */
  privacy: `${LANDING}/privacy/`,
  /** Согласие на обработку персональных данных: текст, который даётся формой. */
  consent: `${LANDING}/legal/`,
} as const;

/** Атрибуты внешней ссылки на документ: новая вкладка и безопасный переход. */
export const LEGAL_LINK_PROPS = {
  target: '_blank',
  rel: 'noreferrer noopener',
} as const;
